export default __webpack_public_path__ + "static/media/waveBlue.26a0bc60.svg";